module.exports = __webpack_public_path__ + "img/giris.90646d58.jpg";